namespace GeniuzPOS.InitialData {
    export interface PsConnectEdcPortForm {
        ConnectEdcPort: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
    }

    export class PsConnectEdcPortForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsConnectEdcPort';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsConnectEdcPortForm.init)  {
                PsConnectEdcPortForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsConnectEdcPortForm, [
                    'ConnectEdcPort', w0,
                    'Remark', w0
                ]);
            }
        }
    }
}
